import { useState } from 'react';

import { useTranslation } from '@lyearn/i18n';
import { cn } from '@lyearn/style';
import { Typography } from '@lyearn/ui';
import * as ContentEditor from '@/components/ContentEditor';
import Loader from '@/components/Loader';
import { Modal } from '@/components/Modals';
import { ModalVariant } from '@/components/Modals/types';

import useSkills from '../../../../../skills/hooks/useSkills';
import useScorecardActions from '../../hooks/useScorecardActions';
import {
  getInitialValues,
  ScorecardCreatorFormValues,
} from '../../views/ScorecardCreator/config/form';
import useScorecardFormProps from '../../views/ScorecardCreator/hooks/useScorecardFormProps/useScorecardFormProps';
import { formContainerStyles, modalHeaderStyles } from './styles';

function ScorecardCreatorModal({ onClose }: { onClose: () => void }) {
  const { t } = useTranslation('Scorecard');

  const [formikSubmit, setFormikSubmit] = useState();
  const { fetching: fetchingSkills, skills } = useSkills({ ids: [] });
  const { disabled: isSubmitting, onSubmit } = useScorecardActions(undefined, onClose);
  const formProps = useScorecardFormProps({ formTitle: t('Scorecard:NewScorecard'), skills });

  return (
    <Modal
      action={{
        onSubmit: formikSubmit!,
        text: t('Common:Actions.Create'),
        isSubmitting,
        className: 'border-t border-divider',
      }}
      closeButton={{ className: 'mt-8 me-12', size: 'large' }}
      header={{
        title: (
          <Typography color="text-text-secondary" variant="body-short-01">
            {t('Scorecard:NewScorecard')}
          </Typography>
        ),
        className: cn('border-b border-divider', modalHeaderStyles),
      }}
      variant={ModalVariant.ExtraWide}
      onClose={onClose}>
      {fetchingSkills ? (
        <Loader />
      ) : (
        <ContentEditor.Main>
          <ContentEditor.Form<ScorecardCreatorFormValues>
            containerClassName={formContainerStyles}
            initialValues={getInitialValues()}
            setSubmitRef={setFormikSubmit}
            onSubmit={onSubmit}
            {...formProps}
          />
        </ContentEditor.Main>
      )}
    </Modal>
  );
}

export default ScorecardCreatorModal;
